<template>
    <div >
        <app-hero-section></app-hero-section>
        <app-highlighted-services></app-highlighted-services>
        <app-highlighted-other-services-new></app-highlighted-other-services-new>
        <app-highlighted-news-new></app-highlighted-news-new>
        <!-- <app-highlighted-other-services></app-highlighted-other-services> -->
        <app-highlighted-about-us></app-highlighted-about-us>
        <app-highlighted-infographics-new></app-highlighted-infographics-new>
        <app-highlighted-interactive-map></app-highlighted-interactive-map>
        <app-highlighted-locations-survey></app-highlighted-locations-survey>
        <!-- <app-highlight-news></app-highlight-news> -->
        <!-- <app-highlighted-products></app-highlighted-products>
        <div class="row mt-2">
            <div class="col-md-12">
                <app-featured></app-featured>
            </div>
        </div> -->
        <!-- <div class="col-md-3 form-group">
            <app-business-entities-profile-home></app-business-entities-profile-home>
            <app-highlighted-infographics></app-highlighted-infographics>
        </div> -->
        
    </div>
</template>

<script>
    import HighlightNews from "./HighlightNews.vue"
    import HighlightedProducts from "./products/HighlightedProducts"
    //import HighlightedPublications from "./publications/HighlightedPublications"
    import MobileAppStore from "./MobileAppStore.vue"
    //import SocialNetworks from "./SocialNetworks.vue"
    //import NfisConnect from "./NFISConnect.vue"
    //import FinancialReportControlsHomeButton from "./rfi/FinancialReportControlsHomeButton"
    //import RedPortalConnect from "./RedPortalConnect.vue"
    //import FeaturedTopics from "./FeaturedTopics.vue"
    import getHighlightedInfographics from "./infographics/InfographicHighlight.vue"
    import Featured from "./featured/Featured.vue"
    import BusinessEntitiesProfileHome from "./BusinessEntitiesProfileHome.vue"
    import HeroSection from "./HeroSection.vue"
    import HighlightedServices from "./HighlightedServices.vue"
    import HighlightedNewsNew from "./HighlightedNewsNew.vue"
    import HighlightedAboutUs from "./about-us/HighlightedAboutUs.vue"
    import HighlightedOtherServices from "./other-services/HighlightedOtherServices.vue"
    import HighlightedLocationsSurvey from "./HighlightedLocationsSurvey.vue"
    import HighlightedInfographicsNew from "./infographics-new/HighlightedInfographicsNew.vue"
    import HighlightedOtherServicesNew from "./HighlightedOtherServicesNew.vue"
    import HiglightedInteractiveMap from "./HiglightedInteractiveMap.vue"
    
    export default {
        components: {
            appHighlightNews: HighlightNews,
            appHighlightedProducts: HighlightedProducts,
            appMobileAppStore: MobileAppStore,
            //appSocialNetworks: SocialNetworks,
            //appNfisConnect: NfisConnect,
            //appRedPortalConnect: RedPortalConnect,
            //appHighlightPublications: HighlightedPublications,
            //appFeaturedTopics: FeaturedTopics,
            appHighlightedInfographics: getHighlightedInfographics,
            appFeatured: Featured,
            appBusinessEntitiesProfileHome: BusinessEntitiesProfileHome,
            appHeroSection: HeroSection,
            appHighlightedServices: HighlightedServices,
            appHighlightedNewsNew: HighlightedNewsNew,
            appHighlightedAboutUs: HighlightedAboutUs,
            appHighlightedOtherServices: HighlightedOtherServices,
            appHighlightedLocationsSurvey: HighlightedLocationsSurvey,
            appHighlightedInfographicsNew : HighlightedInfographicsNew,
            appHighlightedOtherServicesNew : HighlightedOtherServicesNew,
            appHighlightedInteractiveMap: HiglightedInteractiveMap
        },
        mounted() {
            this.$store.state.isSearching = false;
            this.$store.state.search.params.text = "";
        }
    }



</script>

<style scoped>
</style>
